import { inject, Injectable } from '@angular/core';
import { AlertVoiceService } from '@kanzi-apes/kanzi-alerts';
import { Router } from '@angular/router';
import { injectMutation } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { UsersWMSService } from '../services/users-wms/users-wms.service';
import {
  ICreateUserWms,
  IUpdateUserConfigWms,
} from '../models/create-user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserMutations {
  private usersWMSService = inject(UsersWMSService);
  private notifications = inject(AlertVoiceService);
  private router = inject(Router);

  public createUser = injectMutation((client) => {
    const mutation = {
      mutationFn: (body: ICreateUserWms) =>
        lastValueFrom(this.usersWMSService.createUser(body)),
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ['userWMSList'] });
        // this.notifications.success({
        //   msg: 'Bodega creada exitosamente',
        //   title: 'Listo',
        // });
      },
    };

    return mutation;
  });

  public updateUserConfig = injectMutation((client) => {
    const mutation = {
      mutationFn: (body: IUpdateUserConfigWms) =>
        lastValueFrom(this.usersWMSService.updateUserConfigs(body)),
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ['userWMSList'] });
        this.notifications.success({
          msg: 'Usuario actualizado/Creado exitosamente',
          title: 'Listo',
        });
        this.router.navigate(['administration', 'users', 'list']);
      },
    };

    return mutation;
  });
}
